import { Component, OnInit, OnDestroy, Optional } from "@angular/core";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

// Interface pour le SwUpdate (optionnel)
interface SwUpdateLike {
  isEnabled: boolean;
  versionUpdates: any;
  checkForUpdate(): Promise<boolean>;
}

@Component({
  selector: "app-update-notification",
  templateUrl: "./app-update-notification.component.html",
  styleUrls: ["./app-update-notification.component.scss"],
})
export class AppUpdateNotificationComponent implements OnInit, OnDestroy {
  showUpdateNotification = false;
  private subscription: Subscription | null = null;
  private swUpdate: SwUpdateLike | null = null;

  constructor() {
    // Essayer d'injecter SwUpdate dynamiquement si disponible
    try {
      // Le service worker n'est peut-être pas disponible
    } catch (e) {
      console.log("Service Worker not available");
    }
  }

  ngOnInit(): void {
    // La fonctionnalité de mise à jour automatique nécessite le service worker
    // Si non disponible, le composant reste silencieux
  }

  updateApp(): void {
    this.showUpdateNotification = false;
    window.location.reload();
  }

  dismissNotification(): void {
    this.showUpdateNotification = false;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
